import { Alert, Button, Modal } from 'react-bootstrap'

interface IProps {
    show: boolean,
    fullName: string,
    onConfirm: () => void
    onCancel: () => void
}

const ReadyForLabsModal = (props: IProps) => {
    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>Move Candidate to Ready for Labs</Modal.Header>
            <Modal.Body>
                <div style={{ marginBottom: 20, textAlign: 'center' }}>
                    Confirm that you want to move donor <strong>{props.fullName}</strong> to <strong>Ready for Labs</strong>...
                </div>

                <Alert bsStyle='warning'>By clicking the confirmation you are bypassing the donor candidate's ability to follow the email link to confirm they have received the jug.</Alert>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onConfirm}>Confirm</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ReadyForLabsModal;